var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaurus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.25C12.5 9.56521 13.817 12.7446 16.1612 15.0888C18.5054 17.433 21.6848 18.75 25 18.75C28.3152 18.75 31.4946 17.433 33.8388 15.0888C36.183 12.7446 37.5 9.56521 37.5 6.25",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 31.25C12.5 34.5652 13.817 37.7446 16.1612 40.0888C18.5054 42.433 21.6848 43.75 25 43.75C28.3152 43.75 31.4946 42.433 33.8388 40.0888C36.183 37.7446 37.5 34.5652 37.5 31.25C37.5 27.9348 36.183 24.7554 33.8388 22.4112C31.4946 20.067 28.3152 18.75 25 18.75C21.6848 18.75 18.5054 20.067 16.1612 22.4112C13.817 24.7554 12.5 27.9348 12.5 31.25Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaurus);
export default __webpack_public_path__ + "static/media/taurus.e17ddc73a254987b5552fb0956a0bed0.svg";
export { ForwardRef as ReactComponent };